// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../next/Next.bs.js");
var Alert = require("../../../v5/common/Components/Alert.bs.js");
var React = require("react");
var PageTitle = require("../../common/PageTitle.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ProfilePage = require("./ProfilePage.bs.js");
var UserSession = require("../../common/UserSession/UserSession.bs.js");
var PasswordPage = require("./PasswordPage.bs.js");
var LoggedInAgent = require("../../common/UserSession/LoggedInAgent.bs.js");
var MarkupHelpers = require("../../common/MarkupHelpers/MarkupHelpers.bs.js");
var SubusersPageRelay = require("../../../v5/settings/SubusersPageRelay.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var SettingsPageSidebar = require("../../../v5/settings/SettingsPageSidebar.bs.js");
var ReactErrorBoundary = require("react-error-boundary");
var BillingSettingsPageRelay = require("../../../v5/settings/BillingSettingsPageRelay.bs.js");
var EmailPreferencesPageRelay = require("../../../v5/settings/EmailPreferencesPageRelay.bs.js");
var CreateTeamMarketingProfile = require("../../../v5/settings/CreateTeamMarketingProfile.bs.js");
var EditMarketingProfileMember = require("../../../v5/settings/EditMarketingProfileMember.bs.js");
var AddMemberToMarketingProfile = require("../../../v5/settings/AddMemberToMarketingProfile.bs.js");
var TeamMarketingProfileSettings = require("../../../v5/settings/TeamMarketingProfileSettings.bs.js");
var TeamMarketingProfileSlugForm = require("../../../v5/settings/TeamMarketingProfileSlugForm.bs.js");
var AgentMarketingProfileSettings = require("../../../v5/settings/AgentMarketingProfileSettings.bs.js");
var AgentMarketingProfileSlugForm = require("../../../v5/settings/AgentMarketingProfileSlugForm.bs.js");
var TeamMarketingProfileAboutSettings = require("../../../v5/settings/TeamMarketingProfileAboutSettings.bs.js");
var AgentMarketingProfileAboutSettings = require("../../../v5/settings/AgentMarketingProfileAboutSettings.bs.js");
var TeamMarketingProfilePhotosSettings = require("../../../v5/settings/TeamMarketingProfilePhotosSettings.bs.js");
var AgentMarketingProfilePhotosSettings = require("../../../v5/settings/AgentMarketingProfilePhotosSettings.bs.js");
var TeamMarketingProfileMembersSettings = require("../../../v5/settings/TeamMarketingProfileMembersSettings.bs.js");
var TeamMarketingProfileBasicInfoSettings = require("../../../v5/settings/TeamMarketingProfileBasicInfoSettings.bs.js");
var AgentMarketingProfileBasicInfoSettings = require("../../../v5/settings/AgentMarketingProfileBasicInfoSettings.bs.js");
var TeamMarketingProfileSocialAccountsSettings = require("../../../v5/settings/TeamMarketingProfileSocialAccountsSettings.bs.js");
var AgentMarketingProfileSocialAccountsSettings = require("../../../v5/settings/AgentMarketingProfileSocialAccountsSettings.bs.js");

function AccountSettingsPage$Page(props) {
  var __setting = props.setting;
  var setting = __setting !== undefined ? __setting : ["profile"];
  var billingEnabled = UserSession.useChapterPreference("PayingChapter") === "ON";
  var tmp;
  if (setting.length !== 1) {
    tmp = "Settings";
  } else {
    var match = setting[0];
    switch (match) {
      case "billing" :
          tmp = "Billing Settings";
          break;
      case "email_notifications" :
          tmp = "Email Notifications Settings";
          break;
      case "password" :
          tmp = "Password Settings";
          break;
      case "profile" :
          tmp = "Profile Settings";
          break;
      case "users" :
          tmp = "Users Settings";
          break;
      default:
        tmp = "Settings";
    }
  }
  var len = setting.length;
  var tmp$1;
  if (len >= 5) {
    tmp$1 = "This doesn't seem to be a valid URL";
  } else {
    switch (len) {
      case 0 :
          tmp$1 = "This doesn't seem to be a valid URL";
          break;
      case 1 :
          var match$1 = setting[0];
          switch (match$1) {
            case "billing" :
                tmp$1 = billingEnabled ? JsxRuntime.jsx(BillingSettingsPageRelay.make, {}) : "This doesn't seem to be a valid URL";
                break;
            case "email_notifications" :
                tmp$1 = JsxRuntime.jsx(EmailPreferencesPageRelay.make, {});
                break;
            case "marketing_profile" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSettings.make, {});
                break;
            case "password" :
                tmp$1 = JsxRuntime.jsx(PasswordPage.make, {});
                break;
            case "profile" :
                tmp$1 = JsxRuntime.jsx(ProfilePage.make, {});
                break;
            case "team_marketing_profile" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSettings.make, {});
                break;
            case "users" :
                tmp$1 = JsxRuntime.jsx(SubusersPageRelay.make, {});
                break;
            default:
              tmp$1 = "This doesn't seem to be a valid URL";
          }
          break;
      case 2 :
          var match$2 = setting[0];
          switch (match$2) {
            case "marketing_profile" :
                var match$3 = setting[1];
                switch (match$3) {
                  case "about" :
                      tmp$1 = JsxRuntime.jsx(AgentMarketingProfileAboutSettings.make, {});
                      break;
                  case "basic_info" :
                      tmp$1 = JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings.make, {});
                      break;
                  case "photos" :
                      tmp$1 = JsxRuntime.jsx(AgentMarketingProfilePhotosSettings.make, {});
                      break;
                  case "social_media" :
                      tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSocialAccountsSettings.make, {});
                      break;
                  case "url" :
                      tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSlugForm.make, {});
                      break;
                  default:
                    tmp$1 = "This doesn't seem to be a valid URL";
                }
                break;
            case "team_marketing_profile" :
                var match$4 = setting[1];
                switch (match$4) {
                  case "about" :
                      tmp$1 = JsxRuntime.jsx(TeamMarketingProfileAboutSettings.make, {});
                      break;
                  case "basic_info" :
                      tmp$1 = JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings.make, {});
                      break;
                  case "members" :
                      tmp$1 = JsxRuntime.jsx(TeamMarketingProfileMembersSettings.make, {});
                      break;
                  case "new" :
                      tmp$1 = JsxRuntime.jsx(CreateTeamMarketingProfile.make, {});
                      break;
                  case "photos" :
                      tmp$1 = JsxRuntime.jsx(TeamMarketingProfilePhotosSettings.make, {});
                      break;
                  case "social_media" :
                      tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings.make, {});
                      break;
                  case "url" :
                      tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSlugForm.make, {});
                      break;
                  default:
                    tmp$1 = "This doesn't seem to be a valid URL";
                }
                break;
            default:
              tmp$1 = "This doesn't seem to be a valid URL";
          }
          break;
      case 3 :
          var match$5 = setting[0];
          if (match$5 === "team_marketing_profile") {
            var match$6 = setting[1];
            if (match$6 === "members") {
              var match$7 = setting[2];
              tmp$1 = match$7 === "new" ? JsxRuntime.jsx(AddMemberToMarketingProfile.make, {}) : "This doesn't seem to be a valid URL";
            } else {
              tmp$1 = "This doesn't seem to be a valid URL";
            }
          } else {
            tmp$1 = "This doesn't seem to be a valid URL";
          }
          break;
      case 4 :
          var match$8 = setting[0];
          if (match$8 === "team_marketing_profile") {
            var match$9 = setting[1];
            if (match$9 === "members") {
              var memberId = setting[2];
              var match$10 = setting[3];
              tmp$1 = match$10 === "edit" ? JsxRuntime.jsx(EditMarketingProfileMember.make, {
                      memberId: memberId
                    }) : "This doesn't seem to be a valid URL";
            } else {
              tmp$1 = "This doesn't seem to be a valid URL";
            }
          } else {
            tmp$1 = "This doesn't seem to be a valid URL";
          }
          break;
      
    }
  }
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: tmp
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(SettingsPageSidebar.make, {}),
                              className: "col-span-12 md:col-span-4 lg:col-span-3 mb-8 md:mb-0"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
                                    FallbackComponent: (function (_error) {
                                        var tmp;
                                        if (setting.length !== 1) {
                                          tmp = "There was an error loading your settings. Please try again later.";
                                        } else {
                                          var match = setting[0];
                                          switch (match) {
                                            case "marketing_profile" :
                                            case "team_marketing_profile" :
                                                tmp = "There was an error loading your marketing profile. Please try again later.";
                                                break;
                                            default:
                                              tmp = "There was an error loading your settings. Please try again later.";
                                          }
                                        }
                                        return JsxRuntime.jsx(Alert.$$Error.make, {
                                                    title: tmp,
                                                    className: "shadow-sm"
                                                  });
                                      }),
                                    children: tmp$1
                                  }),
                              className: "col-span-12 md:col-span-8 lg:col-span-9"
                            })
                      ],
                      className: "grid grid-cols-12 gap-x-4"
                    })
              ]
            });
}

var Page = {
  make: AccountSettingsPage$Page
};

function AccountSettingsPage$default(props) {
  var setting = props.setting;
  var setting$1 = (setting == null) ? undefined : Caml_option.some(setting);
  var router = Next.useRouter();
  React.useEffect((function () {
          if (setting == null) {
            Next.Router.replace("/account/profile", undefined, undefined, router);
          }
          
        }), [setting$1]);
  return JsxRuntime.jsx(LoggedInAgent.Provider.make, {
              children: JsxRuntime.jsx(AccountSettingsPage$Page, {
                    setting: setting$1
                  })
            });
}

var $$default = AccountSettingsPage$default;

exports.Page = Page;
exports.default = $$default;
exports.__esModule = true;
/* Next Not a pure module */
